import Cookies from 'js-cookie';
import * as actionTypes from '../constants/userConstants';


// Function to check if uaTfl value is available in browser cookies
const isUaTflAvailable = () => {
  const uaTfl = Cookies.get('uaTfl');
  const isLoggedIn = !!uaTfl; // Returns true if uaTfl is available, false otherwise
console.log(isLoggedIn);
  // Update isLoggedIn status in localStorage if uaTfl is not available
  if (!isLoggedIn) {
    localStorage.setItem('isLoggedIn', 'false');
  }

  return isLoggedIn;
};

export const userReducer = (state = { user: {}, isLoggedIn: false, shouldProceedToSignup: false }, action) => {
  switch (action.type) {
    case actionTypes.SIGNIN_REQUEST:
    case actionTypes.SIGNUP_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case actionTypes.SIGNIN_SUCCESS:
    case actionTypes.SIGNUP_SUCCESS:
      localStorage.setItem('isLoggedIn', 'true');
      return {
        ...state,
        loading: false,
        isLoggedIn: true,
        user: action.payload,
      };
    case actionTypes.SIGNOUT_SUCCESS:
      localStorage.setItem('isLoggedIn', 'false');
      return {
        ...state,
        loading: false,
        user: null,
        isLoggedIn: false,
      };
    case actionTypes.SIGNIN_FAIL:
    case actionTypes.SIGNUP_FAIL:
    case actionTypes.SIGNOUT_FAIL:
      return {
        ...state,
        loading: false,
        isLoggedIn: false,
        user: null,
        error: action.payload,
      };
    case actionTypes.CHECK_LOGIN_STATUS:
      return {
        ...state,
        isLoggedIn: action.isLoggedIn,
      };
    case actionTypes.VERIFY_OTP_SUCCESS:
      const isLoggedIn = isUaTflAvailable();
      localStorage.setItem('isLoggedIn', isLoggedIn ? 'true' : 'false');
      return {
        ...state,
        isLoggedIn,
        shouldProceedToSignup: action.payload.shouldProceedToSignup,
        user: action.payload.user,
      };
    case actionTypes.SHOULD_PROCEED_TO_SIGNUP:
      return {
        ...state,
        shouldProceedToSignup: true,
      };
    default:
      return state;
  }
};

const initialState = {
  user: {},
  isLoggedIn: false,
  loading: false,
  error: null,
};

export const currentUserReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_CURRENT_USER_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case actionTypes.GET_CURRENT_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        isLoggedIn: true,
        user: action.payload
      };
    case actionTypes.GET_CURRENT_USER_FAIL:
      return {
        ...state,
        loading: false,
        isLoggedIn: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};



export const otpReducer = (state = { loading: false, error: null }, action) => {
  switch (action.type) {
    case actionTypes.GENERATE_AND_STORE_OTP_REQUEST:
    case actionTypes.VERIFY_OTP_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case actionTypes.GENERATE_AND_STORE_OTP_SUCCESS:
    case actionTypes.VERIFY_OTP_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case actionTypes.GENERATE_AND_STORE_OTP_FAIL:
    case actionTypes.VERIFY_OTP_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};
//Firebase Method

// import * as actionTypes from '../constants/userConstants';

// export const userReducer = (state ={ user: {} }, action) => {
//     switch (action.type) {
//         case actionTypes.LOGIN_REQUESTS:
//         case actionTypes.SIGNUP_REQUESTS:
//             return {
//                 loading: true,
//                 isAuthenticated: false
//             };
//         case actionTypes.LOGIN_REQUESTS_SUCCESS:
//             return {
//                 ...state,
//                 loading: false,
//                 isAuthenticated: true,
//                 user: action.payload
//             };
//         case actionTypes.SIGNUP_REQUESTS_SUCCESS:
//             return {
//                 ...state,
//                 loading: false,
//                 isAuthenticated: true,
//                 user: action.payload
//             };
//         case actionTypes.USER_LOGOUT_REQUESTS_SUCCESS:
//             return {
//                 loading: false,
//                 user: null,
//                 isAuthenticated: false,
//             }
//         case actionTypes.LOGIN_REQUESTS_FAIL:
//         case actionTypes.SIGNUP_REQUESTS_FAIL:
//                 return {
//                    ...state,
//                    loading: false,
//                    isAuthenticated: false,
//                    user: null,
//                    error: action.payload
//                };
//         case actionTypes.USER_LOGOUT_REQUESTS_FAIL:
//                 return {
//                     ...state,
//                     loading: false,
//                     error: action.payload,
//                 }
//             default:
//                 return state;
//     }
// };

// import * as actionTypes from '../constants/userConstants';


// // const initialState = {
// //     user: null,
// //     error: null,
// //     loading: false,
// //     isLoggedIn: false,
// // };

// // export const userReducer = (state = initialState, action) => {
// //     switch (action.type) {
// //         case actionTypes.SIGNIN_REQUEST:
// //         case actionTypes.PHONE_OTP_SIGNIN_REQUEST:
// //             return { ...state, loading: true };
// //         case actionTypes.SIGNIN_SUCCESS:
// //         case actionTypes.PHONE_OTP_SIGNIN_SUCCESS:
// //             return {
// //                 loading: false,
// //                 user: action.payload,
// //                 error: null,
// //                 isLoggedIn: true
// //             };
// //         case actionTypes.SIGNIN_FAIL:
// //         case actionTypes.PHONE_OTP_SIGNIN_FAIL:
// //             return {
// //                 loading: false,
// //                 user: null,
// //                 error: action.payload,
// //                 isLoggedIn: false
// //             };
// //         case actionTypes.SIGNOUT_REQUEST:
// //             return {
// //                 ...state,
// //                 loading: true
// //             }
// //         case actionTypes.SIGNOUT_SUCCESS:
// //             return {
// //                 loading: false,
// //                 user: null,
// //                 error: null,
// //                 isLoggedIn: false
// //             };
// //         case actionTypes.SIGNOUT_FAIL:
// //             return {
// //                 loading: false,
// //                 user: null,
// //                 error: action.payload,
// //                 isLoggedIn: false
// //             };
// //         default:
// //             return state;
// //     }
// // };
// import Cookies from 'js-cookie'
// // const initialState = {
// //     user: null,
// //     error: null,
// //     loading: false,
// //     isLoggedIn: false,
// //     phoneAuth: {
// //         codeSent: false,
// //         confirmationResult: null
// //     }
// // };

// export const userReducer = (state = { user: {} }, action) => {
//     switch (action.type) {
//         case actionTypes.SIGNIN_REQUEST:
//             return { ...state, loading: true };

//         case actionTypes.SIGNIN_SUCCESS:
//             console.log("SIGNIN_SUCCESS: ", action.payload);
//             Cookies.set('uaTfl', action.payload.accessToken, { maxAge: 365 * 24 * 60 * 60 * 1000 });
//             Cookies.set('auTE', action.payload.authTokenExp, { maxAge: 365 * 24 * 60 * 60 * 1000 });
//             return {
//                 ...state,
//                 loading: false,
//                 user: action.payload,
//                 error: null,
//                 isLoggedIn: true
//             };
//             case actionTypes.SIGNIN_FAIL:
//                 console.log("attributes:", action.payload.attributes);
//                 console.log("attributeName:", action.payload.attributeName);
//                 return {
//                   ...state,
//                   loading: false,
//                   user: null,
//                   error: action.payload,
//                   isLoggedIn: false
//                 };
//         case actionTypes.SIGNUP_REQUEST:
//             return { ...state, loading: true };
//         case actionTypes.SIGNUP_SUCCESS:
//             Cookies.set('uaTfl', action.payload.accessToken, { maxAge: 365 * 24 * 60 * 60 * 1000 });
//             Cookies.set('auTE', action.payload.authTokenExp, { maxAge: 365 * 24 * 60 * 60 * 1000 });
//             return {
//                 ...state,
//                 loading: false,
//                 user: action.payload,
//                 error: null,
//                 isLoggedIn: true
//             };
//         case actionTypes.SIGNUP_FAIL:
//             return {
//                 ...state,
//                 loading: false,
//                 user: null,
//                 error: action.payload,
//                 isLoggedIn: false
//             };
//         case actionTypes.SAVE_TOKEN_IN_COOKIE:
//             return {
//                 ...state,
//                 user: {
//                     ...state.user,
//                     token: action.payload,
//                 },
//             };
//         case actionTypes.SIGNOUT_REQUEST:
//             return {
//                 ...state,
//                 loading: true
//             }
//         case actionTypes.SIGNOUT_SUCCESS:
//             return {
//                 ...state,
//                 loading: false,
//                 user: null,
//                 error: null,
//                 isLoggedIn: false
//             };
//         case actionTypes.SIGNOUT_FAIL:
//             return {
//                 ...state,
//                 loading: false,
//                 user: null,
//                 error: action.payload,
//                 isLoggedIn: false
//             };
//         // case actionTypes.SEND_OTP_REQUEST:
//         //     return {
//         //         ...state,
//         //         loading: true
//         //     };
//         // case actionTypes.SEND_OTP_SUCCESS:
//         //     return {
//         //         ...state,
//         //         loading: false,
//         //         phoneAuth: {
//         //             ...state.phoneAuth,
//         //             codeSent: true,
//         //             confirmationResult: action.payload,
//         //         }
//         //     };
//         // case actionTypes.SEND_OTP_FAIL:
//         //     return {
//         //         ...state,
//         //         loading: false,
//         //         error: action.payload,
//         //     };
//         // case actionTypes.VERIFY_OTP_REQUEST:
//         //     return {
//         //         ...state,
//         //         loading: true
//         //     };
//         // case actionTypes.VERIFY_OTP_SUCCESS:
//         //     return {
//         //         ...state,
//         //         loading: false,
//         //         user: action.payload,
//         //         error: null,
//         //         isLoggedIn: true
//         //     };
//         // case actionTypes.VERIFY_OTP_FAIL:
//         //     return {
//         //         ...state,
//         //         loading: false,
//         //         error: action.payload,
//         //     };
//         // case actionTypes.EMAIL_SIGNIN_REQUEST:
//         //     return { ...state, loading: true };
//         // case actionTypes.EMAIL_SIGNIN_SUCCESS:
//         //     return {
//         //         ...state,
//         //         loading: false,
//         //         user: action.payload,
//         //         error: null,
//         //         isLoggedIn: true
//         //     };
//         // case actionTypes.EMAIL_SIGNIN_FAIL:
//         //     return {
//         //         ...state,
//         //         loading: false,
//         //         user: null,
//         //         error: action.payload,
//         //         isLoggedIn: false
//         //     };
//         case actionTypes.GET_CURRENT_USER_REQUEST:
//             return { ...state, loading: true };
//         case actionTypes.GET_CURRENT_USER_SUCCESS:
//             return {
//                 ...state,
//                 loading: false,
//                 user: action.payload,
//                 error: null,
//                 isLoggedIn: true
//             };
//         case actionTypes.GET_CURRENT_USER_FAIL:
//             return {
//                 ...state,
//                 loading: false,
//                 user: null,
//                 error: action.payload,
//                 isLoggedIn: false
//             };
//         default:
//             return state;
//     }
// };